import React from "react";
import { Link } from "react-router-dom";

const SleeveMini = ({ sleeve, showCaption = false }) => {
  return (
    <div className="sleeve-mini-result">
      <div className="sleeve-cover">
        {sleeve.img_path && (
          <Link to={`/sleeves/view/${sleeve.id}`} title={`${sleeve.artist} - ${sleeve.title}`}>
            <img
              src={`https://res.cloudinary.com/dreamchimney/image/upload/w_220/sleevery/${sleeve.id}.jpg`}
              className="sleeve-mini center-block img-responsive"
              alt={sleeve.title}
            />
          </Link>
        )}
      </div>
      {showCaption && (
        <Link to={`/sleeves/view/${sleeve.id}`} className="sleeve-mini-caption" title={`${sleeve.artist} - ${sleeve.title}`}>
          <div className="sleeve-mini-title">{sleeve.title}</div>
          <div className="sleeve-mini-meta">{sleeve.artist}</div>
        </Link>
      )}
    </div>
  );
};

export default SleeveMini;
